"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const silo_hopper_types_1 = require("./silo-hopper.types");
const moment_1 = __importDefault(require("moment"));
const initialState = {
    isError: false,
    isLoading: true,
    isSuccess: false,
    isExport: false,
    mutationMode: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataGridHistory: [],
    isLoadingManual: false,
    isLoadingUpload: false,
    isLoadingExport: false,
    isLoadingDeleted: false,
    isLoadingHistory: false,
    isLoadingDownload: false,
    isLoadingCorrection: false,
    dataGridDeletedList: [],
    dataSiloTrip: [],
    dataSiloTon: [],
    dropdownContractor: [],
    dropdownDriver: [],
    dropdownVessel: [],
    dropdownSilo: [],
    dropdownHauler: [],
    dropdownBrand: [],
    dataVesselCorrection: [],
    isSubmit: false,
    isLoadingModify: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    lastUpdated: new Date(),
    start_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    end_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    dataItem: {
        id: '',
        hopper_transaction_silo_id: '',
        contractor_id: '',
        contractor_name: '',
        brand_id: '',
        brand_code: '',
        brand_name: '',
        brand_color: '',
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel_1_id: '',
        vessel_1_no: '',
        vessel_2_id: '',
        vessel_2_no: '',
        driver_id: '',
        driver_name: '',
        silo_checkpoint_id: '',
        hopper_checkpoint_id: '',
        hopper: '',
        // silo: '',
        ticket_no: '',
        main_entrance_in: new Date(),
        gate_in: new Date(),
        gate_out: new Date(),
        date: '',
        time_in: new Date(),
        time_out: new Date(),
        queque_time_in: '',
        transaction_type: '',
        capacity_volume_1: 0,
        capacity_volume_2: 0,
        total_volume: 0,
        is_active: false,
        is_delete: false,
        is_duplicate: false,
        reason: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        contractor: {
            id: '',
        },
        driver: {
            id: '',
        },
        vessel_1: {
            id: '',
        },
        vessel_2: {
            id: '',
        },
        silo: {
            id: '',
        },
        hauler: {
            id: '',
        },
        brand: {
            id: '',
        },
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_delete', operator: 'eq', value: false }],
        },
    },
    dataItemDeletedList: {
        id: '',
        hopper_transaction_silo_id: '',
        contractor_id: '',
        contractor_name: '',
        brand_id: '',
        brand_code: '',
        brand_name: '',
        brand_color: '',
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel_1_id: '',
        vessel_1_no: '',
        vessel_2_id: '',
        vessel_2_no: '',
        driver_id: '',
        driver_name: '',
        silo_checkpoint_id: '',
        hopper_checkpoint_id: '',
        hopper: '',
        // silo: '',
        ticket_no: '',
        main_entrance_in: new Date(),
        gate_in: new Date(),
        gate_out: new Date(),
        date: '',
        time_in: new Date(),
        time_out: new Date(),
        queque_time_in: '',
        transaction_type: '',
        capacity_volume_1: 0,
        capacity_volume_2: 0,
        total_volume: 0,
        is_active: false,
        is_delete: false,
        is_duplicate: false,
        reason: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        contractor: {
            id: '',
        },
        driver: {
            id: '',
        },
        vessel_1: {
            id: '',
        },
        vessel_2: {
            id: '',
        },
        silo: {
            id: '',
        },
        hauler: {
            id: '',
        },
        brand: {
            id: '',
        },
    },
    dataStatesDeletedList: {
        skip: 0,
        take: 10,
        total: 0,
        sortable: true,
        filterable: true,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
    dataItemHistory: {
        id: '',
        type: '',
        status: '',
        filename: '',
        filepath: '',
        log_message: '',
        uploaded_by: '',
        uploaded_at: new Date(),
    },
    dataStatesHistory: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'uploaded_at', dir: 'desc' }],
        filter: {
            logic: 'and',
            filters: [
                { field: 'type', operator: 'contains', value: 'Export Silo Hopper' },
            ],
        },
    },
};
const adjustmentSiloReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count, dataSiloTon, dataSiloTrip } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataSiloTon,
            dataSiloTrip, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_CHECK_FILTER]: (state, action) => {
        const { dataVesselCorrection } = action.payload;
        return Object.assign(Object.assign({}, state), { dataVesselCorrection });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_VESSEL]: (state, action) => {
        const { dataVesselCorrection } = action.payload;
        return Object.assign(Object.assign({}, state), { dataVesselCorrection, isLoadingCorrection: false });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates,
            dataGrid, isLoading: false });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, isSubmit, isSuccess, isExport, mutationMode, isLoadingManual, dataItemHistory, isLoadingModify, isLoadingExport, isLoadingUpload, isLoadingDeleted, isLoadingHistory, isLoadingDownload, isLoadingCorrection, dataVesselCorrection, } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSubmit: isSubmit ? isSubmit : initialState.isSubmit, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isExport: isExport ? isExport : initialState.isExport, isLoadingManual: isLoadingManual
                ? isLoadingManual
                : initialState.isLoadingManual, dataItemHistory: dataItemHistory
                ? dataItemHistory
                : initialState.dataItemHistory, isLoadingModify: isLoadingModify
                ? isLoadingModify
                : initialState.isLoadingModify, isLoadingExport: isLoadingExport
                ? isLoadingExport
                : initialState.isLoadingExport, isLoadingUpload: isLoadingUpload
                ? isLoadingUpload
                : initialState.isLoadingUpload, isLoadingHistory: isLoadingHistory
                ? isLoadingHistory
                : initialState.isLoadingHistory, isLoadingDeleted: isLoadingDeleted
                ? isLoadingDeleted
                : initialState.isLoadingDeleted, isLoadingDownload: isLoadingDownload
                ? isLoadingDownload
                : initialState.isLoadingDownload, isLoadingCorrection: isLoadingCorrection
                ? isLoadingCorrection
                : initialState.isLoadingCorrection, dataVesselCorrection: dataVesselCorrection
                ? dataVesselCorrection
                : initialState.dataVesselCorrection });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoadingManual: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map((item) => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_SAVE_DATAITEM_CORRECTION]: (state, action) => {
        const { isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataVesselCorrection: [] });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isSubmit: false, isLoading: false, isSuccess: false, isLoadingManual: false, isLoadingModify: false, isLoadingExport: false, isLoadingUpload: false, isLoadingDeleted: false, isLoadingHistory: false, isLoadingDownload: false, isLoadingCorrection: false });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload.isLoading });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_DELETED_LIST]: (state, action) => {
        const { count, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, dataGridDeletedList: dataGrid, dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { total: count, skip: initialState.dataStates.skip }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE_DELETED_LIST]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { isLoading: true, filter: action.payload }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE_DELETED_LIST]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesDeletedList: Object.assign(Object.assign({}, state.dataStatesDeletedList), { isLoading: true, sort: action.payload }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE_DELETED_LIST]: (state, action) => {
        const { dataGrid, dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesDeletedList: dataStates, dataGridDeletedList: dataGrid, isLoading: false });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_DELETE_REASON]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false, dataItem: initialState.dataItem, isSuccess: action.payload.isSuccess });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingHistory: false, dataGridHistory: action.payload.dataGridHistory, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: action.payload.countData }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_LAST_SUCCEED_UPLOAD]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, lastUpdated: action.payload.lastUpdated });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: action.payload.dataStatesHistory });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { filter: action.payload }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { sort: action.payload }) });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_DATE_CHANGE]: (state, action) => {
        const { start_date, end_date } = action.payload;
        return Object.assign(Object.assign({}, state), { start_date, end_date: end_date ? end_date : (0, moment_1.default)().format('YYYY-MM-DD'), isLoading: true });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_EXPORT_DOCUMENTS_URL]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isExport: true, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.CLEAR_EXPORT_DOCUMENTS_URL]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoadingExport: false, documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_CONTRACTOR]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingModify: false, dropdownContractor: action.payload.dropdownContractor });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingModify: false, dropdownBrand: action.payload.dropdownBrand });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_SILO]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoadingModify: false, dropdownSilo: action.payload.dropdownSilo });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_DRIVER]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dropdownDriver: action.payload.dropdownDriver });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_VESSEL]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dropdownVessel: action.payload.dropdownVessel });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_HAULER]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dropdownHauler: action.payload.dropdownHauler });
    },
    [silo_hopper_types_1.adjustmentSiloTypes.ON_MODIFY_TICKET_SILO]: (state) => {
        return Object.assign(Object.assign({}, state), { isSuccess: true, isLoading: true, mutationMode: false });
    },
});
exports.default = adjustmentSiloReducer;
